export const LINKS = {
    PRIVACY_WIKI: "https://w.amazon.com/bin/view/Kale/",
    ORG_SPECIFIC_WIKI: "https://w.amazon.com/bin/view/Kale/OrgSpecificGuidance/",
    B2B_WIKI: "https://w.amazon.com/bin/view/CDOPrivacy/Privacy_Reviews/B2B_Campaign/",
    HR_WIKI: "https://w.amazon.com/bin/view/HRRiskAndCompliance/EnterpriseHRRisk/HRPrivacyReviews/",
    LEGAL_DATA_MAPPING: "https://legal.amazon.com/sites/LegalTeams/LitandReg/Pages/Conducting-Data-Mapping.aspx",
    LEGAL_INFO_WIKI: "https://w.amazon.com/bin/view/CDOPrivacy/Privacy_Reviews#HPrivacyReviewGroups",
    DATA_ELEMENT_REGISTRY: "https://der.data-governance.privacy.a2z.com/",
};
